<template>
  <div class="page-wrapper" :class="{'haveHead':!$route.meta.headerHide}">
    <Header v-if="!$route.meta.headerHide"></Header>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <Footer v-if="!$route.meta.footerHide"></Footer>
  </div>
</template>
<script>
import Header from '@/views/home/Header.vue'
import Footer from '@/views/home/Footer.vue'
export default {
  name: 'app',
  components: {  Footer, Header},
  mounted(){
    const script = document.createElement('script');
    script.src = '/js/custom-script.js';
    document.body.appendChild(script);
  }
}

</script>
<style lang="scss">
//@import "@/style/style.scss";
	@import '@/style/iconfont/iconfont.css';

.haveHead {
  padding-top: var(--top-app-bar-height);
}
.page-wrapper{
  position: relative;
  overflow: hidden;
	min-height: calc(100vh);
	padding-bottom: 80px;
}
</style>
